import styled, { css } from 'styled-components'

import { btnSecondaryBg, defaultAnimationOpacityEase, transition } from '../../../utils/style-utils'

interface Props {
  isActive?: boolean
}

export const Item = styled.div.withConfig<Props>({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})`
  display: flex;
  height: 100%;
  aspect-ratio: 4/3;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  scroll-snap-align: start;
  border-bottom: 1px solid transparent;

  ${transition('background-color, border-bottom-color', 0.4, defaultAnimationOpacityEase)}

  ${({ isActive }) =>
    isActive
      ? css`
          background-color: ${btnSecondaryBg};
          border-bottom-color: ${btnSecondaryBg};
        `
      : ''}
`
